module.exports = "<div class=\"row\">\r\n    <div class=\"col-xs-12 col-md-6\">\r\n\r\n    </div>\r\n    <div class=\"col-xs-12 col-md-6\">\r\n\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets/layout.two-equal-cols.html
// module id = 622
// module chunks = 0